export const CONFIRMATION_DEFAULTS = {
  welcome:
    "We're thrilled that you've joined as a Member, thank you! In order to complete the registration process for your account, you will need to visit your email inbox and click on the link to confirm your email. Thank you again and feel welcome reaching us with any questions you may have!",

  whatToExpect:
    "Here's what happens next:\n\n" +
    "- You'll receive a confirmation email with your login details\n" +
    "- Check your email and click the verification link\n" +
    "- Once verified, you can log in and access your account\n" +
    "- Your first class will be based on the schedule you selected",

  schedule:
    "Your class schedule is based on the programs you selected during registration. You can view your full schedule by logging into your account. If you need to make changes to your schedule, please contact us.",

  manageAccount:
    "After verifying your email, you can log into your account to:\n\n" +
    "- View and update your profile information\n" +
    "- See your athlete details and class schedules\n" +
    "- View billing history and make payments\n" +
    "- Contact us with questions or requests",
};
